export const CONFIG = {
  //api: 'https://api-stag.agtran.com',
  //graphql: 'https://api-stag.agtran.com/graphql'
  //api: 'http://localhost:3000',
  //graphql: 'http://localhost:3000/graphql'
  api: 'https://api.agtran.com',
  graphql: 'https://api.agtran.com/graphql'
  // api: 'https://agtran-api.zeem.com.my',
  // graphql: 'https://agtran-api.zeem.com.my/graphql'
}